import { render } from "./TargetModal.vue?vue&type=template&id=03657d86&scoped=true"
import script from "./TargetModal.vue?vue&type=script&lang=js"
export * from "./TargetModal.vue?vue&type=script&lang=js"

import "./TargetModal.vue?vue&type=style&index=0&id=03657d86&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03657d86"]])

export default __exports__